{
    "common": {
        "action": "Actie",
        "back": "Terug",
        "clockOut": "Uitklokken",
        "from": "Van",
        "logout": "Uitloggen",
        "next": "Volgende",
        "skip": "Overslaan",
        "submit": "Bevestigen",
        "until": "tot",
        "wholeDay": "Hele dag"
    },
    "containers": {
        "cacheBuster": {
            "updateAvailable": "Er is een update beschikbaar!",
            "reload": "Herlaad"
        },
        "clockOutScreen": {
            "title": "Klaar om je werkdag te stoppen, :firstName:?",
            "titleNoName": "Klaar om je werkdag te stoppen?"
        },
        "commentScreen": {
            "startedWithoutShiftTitle": "Geef de reden op waarom je zonder dienst bent gestart.",
            "trackDivergenceTitle": "Zo te zien wijken jouw tijden af van de planning. Wat is de reden?"
        },
        "happinessScreen": {
            "title": "Wat vond je van jouw werkdag?"
        },
        "inactiveScreen": {
            "title": "Helaas, je hebt geen toegang tot de ValkTimer",
            "intro": "Jouw account is gedeactiveerd waardoor je geen toegang meer hebt tot de functionaliteiten in de ValkTimer.",
            "contact": "Klopt dit niet of heb je vragen? Neem contact op met jouw manager of personeelszaken."
        },
        "goodbyeScreen": {
            "title": "Fijne dag en tot ziens!"
        },
        "loginScreen": {
            "enterPincode": "Voer je pincode in",
            "userNotFound": "Helaas, deze combinatie is onjuist. Voer opnieuw je medewerkers code in",
            "title": "Welkom, voer je medewerkers code in"
        },
        "masterLoginScreen": {
            "title": "Welkom, voer de mastercode in om toegang te krijgen tot de ValkTimer",
            "wrongMasterCode": "Helaas, deze combinatie is onjuist. Voer opnieuw de mastercode in"
        },
        "mealScreen": {
            "title": "Welke maaltijd heb je genomen?"
        },
        "pauseScreen": {
            "title": "Hoeveel minuten pauze heb je gehad?"
        },
        "selectShiftScreen": {
            "pleasantWorkDay": "Fijne werkdag, :firstName:!",
            "unplannedShift": "Ongeplande dienst",
            "whichShiftDoYouWantToStart": "Welke dienst wil je starten, :firstName:?"
        }
    },
    "errors": {
        "unknownError": "Er is een onbekende fout opgetreden, probeer het later opnieuw"
    },
    "types": {
        "mealType": {
            "hot": "Warm",
            "bread": "Brood",
            "none": "Geen"
        }
    }
}
